import React, { useEffect, createElement } from 'react';
export function PractitionersPage() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://server.fillout.com/embed/v1/';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <main className="min-h-screen bg-ivory font-sans text-charcoal selection:bg-purple-200 selection:text-charcoal" data-id="element-438" data-mp="2ze39l2u90mwa">
      {/* Navigation */}
      <nav className="absolute top-0 left-0 right-0 z-50 px-6 py-6 flex justify-between items-center max-w-7xl mx-auto" data-id="element-439" data-mp="3s178cq2r04zm">
        <a href="/" data-id="element-440" data-mp="3n0ruzyiguxhn">
          <img src="https://cdn.magicpatterns.com/uploads/xpYure8muF9bisffxXgVg2/fementity.png" alt="Fem Entity" className="h-12 md:h-16 drop-shadow-lg" data-id="element-441" data-mp="3n09om923b2w0" />
        </a>
        <div className="hidden md:flex space-x-8 text-sm font-medium text-charcoal/80" data-id="element-442" data-mp="2bnz6qxovwr6c">
          <a href="/" className="hover:text-purple-700 transition-colors" data-id="element-443" data-mp="26m03dnt59u9e">
            Home
          </a>
          <a href="/practitioners" className="text-purple-700 transition-colors" data-id="element-444" data-mp="zm5h1ub5z3b0">
            Practitioners
          </a>
          <a href="/investors" className="hover:text-purple-700 transition-colors" data-id="element-445" data-mp="pnzh3i8x478s">
            Investors
          </a>
        </div>
      </nav>

      <section className="pt-40 pb-24 px-6" data-id="element-446" data-mp="fxn0g1484y7x">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-447" data-mp="fwle30hrcpaw">
          <span className="inline-block text-xs font-medium tracking-[0.2em] uppercase text-purple-700 mb-5" data-id="element-448" data-mp="komw731lxa8u">
            For Practitioners
          </span>
          <h1 className="text-4xl md:text-6xl font-serif text-charcoal leading-[1.1] mb-6 tracking-tight" data-id="element-449" data-mp="6ultjy7jb337">
            Join the Network
          </h1>
          <p className="text-lg md:text-xl text-charcoal/70 font-light leading-relaxed" data-id="element-450" data-mp="3t3n0w2i4h60w">
            Become part of a curated community of trusted practitioners shaping
            the future of women's wellness. Complete the form below to apply.
          </p>
        </div>

        <div className="max-w-3xl mx-auto rounded-3xl border border-purple-100 bg-white/80 backdrop-blur-md shadow-xl p-2 md:p-4" data-id="element-451" data-mp="3a7o611jfnf5l">
          <div style={{
          width: '100%',
          height: 500
        }} data-fillout-id="5TKe1b8U6sus" data-fillout-embed-type="standard" data-fillout-inherit-parameters data-fillout-dynamic-resize data-id="element-452" data-mp="359mr8st1i1zx"></div>
        </div>
      </section>

      {/* Minimal Footer */}
      <footer className="bg-charcoal text-ivory/50 py-8 border-t border-white/10" data-id="element-453" data-mp="3swb8rde4zsg0">
        <div className="max-w-7xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6 text-sm" data-id="element-454" data-mp="3o15qqpnuuxx7">
          <p data-id="element-455" data-mp="2cjnx4izzneoe">© {new Date().getFullYear()} Fem Entity. All rights reserved.</p>
          <a href="/privacy-policy" className="hover:text-ivory transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-300 rounded" data-id="element-456" data-mp="2chjip74gqx9v">
            Privacy Policy
          </a>
        </div>
      </footer>
    </main>;
}